var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M7.99967 14.6666C11.6816 14.6666 14.6663 11.6818 14.6663 7.99992C14.6663 4.31802 11.6816 1.33325 7.99967 1.33325C4.31778 1.33325 1.33301 4.31802 1.33301 7.99992C1.33301 11.6818 4.31778 14.6666 7.99967 14.6666Z",
    fill: "#9B9393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7069 7.99999L10.2402 6.46666C10.4336 6.27332 10.4336 5.95332 10.2402 5.75999C10.0469 5.56666 9.7269 5.56666 9.53357 5.75999L8.00023 7.29332L6.4669 5.75999C6.27357 5.56666 5.95357 5.56666 5.76023 5.75999C5.5669 5.95332 5.5669 6.27332 5.76023 6.46666L7.29357 7.99999L5.76023 9.53332C5.5669 9.72666 5.5669 10.0467 5.76023 10.24C5.86023 10.34 5.9869 10.3867 6.11357 10.3867C6.24023 10.3867 6.3669 10.34 6.4669 10.24L8.00023 8.70666L9.53357 10.24C9.63357 10.34 9.76023 10.3867 9.8869 10.3867C10.0136 10.3867 10.1402 10.34 10.2402 10.24C10.4336 10.0467 10.4336 9.72666 10.2402 9.53332L8.7069 7.99999Z",
    fill: "#9B9393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.c81e4801d693eed907598e3a63fdf5de.svg";
export { ForwardRef as ReactComponent };